module.exports = __webpack_public_path__ + "static/media/12813.45063730.jpg";